/** 타입라이터(한 글자씩 표시) 상태 머신 — BattleDialogueOverlay 내부 전용. */

export const TYPEWRITER_CHAR_DELAY = 28;

export interface TypewriterState {
  chars: string[];
  index: number;
  active: boolean;
  event: Phaser.Time.TimerEvent | undefined;
  renderedLineIndex: number;
  renderedLineText: string;
}

export function createTypewriterState(): TypewriterState {
  return {
    chars: [],
    index: 0,
    active: false,
    event: undefined,
    renderedLineIndex: -1,
    renderedLineText: "",
  };
}

export function startTypewriter(
  state: TypewriterState,
  text: string,
  scene: Phaser.Scene,
  onTick: () => void,
): void {
  stopTypewriter(state);
  state.chars = Array.from(text);
  state.index = 0;
  state.active = state.chars.length > 0;
  if (!state.active) return;
  state.event = scene.time.addEvent({
    delay: TYPEWRITER_CHAR_DELAY,
    loop: true,
    callback: onTick,
  });
}

/** 다음 글자를 드러낸다. 전부 완료되면 true. */
export function revealNextChar(state: TypewriterState): { text: string; done: boolean } {
  if (!state.active) return { text: "", done: true };
  state.index = Math.min(state.index + 1, state.chars.length);
  const text = state.chars.slice(0, state.index).join("");
  const done = state.index >= state.chars.length;
  if (done) {
    stopTypewriter(state, false);
  }
  return { text, done };
}

/** 클릭 시 즉시 완료. 이미 완료 상태면 false. */
export function completeTypewriter(state: TypewriterState): { completed: boolean; text: string } {
  if (!state.active) return { completed: false, text: "" };
  const text = state.chars.join("");
  state.index = state.chars.length;
  stopTypewriter(state, false);
  return { completed: true, text };
}

export function stopTypewriter(state: TypewriterState, clearText = true): void {
  state.event?.remove(false);
  state.event = undefined;
  state.active = false;
  state.index = 0;
  state.chars = [];
  // clearText는 호출자가 bodyText.setText("")로 처리
  void clearText;
}
